import { SiGithub, SiGitlab } from '@icons-pack/react-simple-icons';
import { Cloud, FlaskConical } from 'lucide-react';
import { PROVIDER_ACCENT } from '../lib/graph-visuals';
import { cn } from '../lib/utils';

/**
 * The brand mark for an integration source (Bedrock icon system — replaces the old
 * provider emoji). GitHub & GitLab use their real monochrome marks;
 * the clouds (AWS/GCP/Azure, whose logos aren't redistributable) share a single
 * Cloud glyph tinted with the provider's accent and are disambiguated by their
 * adjacent name; the sandbox uses a flask. Decorative by default (aria-hidden).
 */
export function ProviderLogo({
  provider,
  size = 16,
  className,
}: {
  provider?: string | null;
  size?: number;
  className?: string;
}) {
  const p = (provider ?? '').toUpperCase();
  const cls = cn('shrink-0', className);
  switch (p) {
    case 'GITHUB':
      // GitHub's mark is near-black; follow the theme text colour so it stays legible.
      return <SiGithub size={size} color="currentColor" className={cls} aria-hidden />;
    case 'GITLAB':
      return <SiGitlab size={size} className={cls} aria-hidden />;
    case 'SANDBOX':
      return <FlaskConical size={size} className={cls} aria-hidden />;
    case 'AWS':
    case 'AZURE':
    case 'GCP':
      return (
        <Cloud size={size} className={cls} style={{ color: PROVIDER_ACCENT[p] }} aria-hidden />
      );
    default:
      return <Cloud size={size} className={cls} aria-hidden />;
  }
}
